import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_HOUSEHOLD_MARK_RENTER_PREQUAL_AS_COMPLETED,
} from 'api/actionTypes';

export default async function markRenterPrequalAsCompleted(
  { state, apiClient },
  { userId, listingId },
) {
  typeCheck('userId::PositiveNumber', userId);
  typeCheck('listingId::Maybe PositiveNumber', listingId);

  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_MARK_RENTER_PREQUAL_AS_COMPLETED,
    queryId: String(userId),
    state: state,
    payload: {
      userId,
      listingId,
    },
    onSuccess(renterProfile) {
      state.set(['household', 'renterProfilesByUserId', userId], renterProfile);
    },
  });
}
